var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bag-Fm-Handover"
  }, [_c('div', {
    staticClass: "animated fadeInDown",
    attrs: {
      "id": "FmBagHandover"
    }
  }, [_c('fieldset', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.handoverList.length > 0) ? _c('table', {
    staticClass: "table-box"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.handoverList), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm._f("moment")(row.createdAt, 'DD-MM-YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.totalBags))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.userName) + " (" + _vm._s(row.handoverRequestFrom) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.vehicleNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.handoverRequestBatchId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn-status-sm",
      class: {
        'status-pending-orange': row.handoverRequestBatchStatus === 'PENDING'
      },
      attrs: {
        "disabled": row.handoverRequestBatchStatus === 'Approved'
      },
      on: {
        "click": function($event) {
          return _vm.openModal(row)
        }
      }
    }, [_vm._v("\n         " + _vm._s(row.handoverRequestBatchStatus) + "\n        ")])])])
  }), 0)]) : _c('p', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center",
      "color": "#666"
    }
  }, [_vm._v("\n        No pending request found.\n      ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "handover-request-modal",
      "size": "lg",
      "hide-footer": "",
      "centered": "",
      "no-enforce-focus": "",
      "body-class": "p-0"
    },
    model: {
      value: (_vm.showDetailsforRequestIdModal),
      callback: function($$v) {
        _vm.showDetailsforRequestIdModal = $$v
      },
      expression: "showDetailsforRequestIdModal"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Handover Request")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeBagDetailModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Batch Request Id:")]), _vm._v(" "), _c('span', {
    staticClass: "batch-id-text"
  }, [_vm._v(_vm._s(_vm.currentRequestId))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Total Bags :")]), _vm._v(" "), _c('strong', {
    staticClass: "total-bags-highlight"
  }, [_vm._v(_vm._s(_vm.scannedCount) + " / " + _vm._s(_vm.totalBags))])])]), _vm._v(" "), (_vm.handoverStarted) ? _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "border-top": "1px solid #2ab2db",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Scan Bags")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scannedBagInput),
      expression: "scannedBagInput"
    }],
    ref: "scanInput",
    staticClass: "form-control",
    class: {
      'border-danger': _vm.inputError
    },
    attrs: {
      "type": "text",
      "placeholder": "Scan Bag No"
    },
    domProps: {
      "value": (_vm.scannedBagInput)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.scanBag.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scannedBagInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.inputError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Bag Seal is empty")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('button', {
    staticClass: "common-success btn",
    on: {
      "click": _vm.scanBag
    }
  }, [_vm._v("Inscan")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary ml-2",
    staticStyle: {
      "height": "38px"
    },
    on: {
      "click": _vm.resetScan
    }
  }, [_vm._v("Reset")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pill-container mb-3"
  }, _vm._l((_vm.priorityData.priorityCounts), function(count, key) {
    return _c('button', {
      key: key,
      class: ['btn-pill', _vm.selectedPriority === key ? 'active' : ''],
      on: {
        "click": function($event) {
          return _vm.selectPriority(key)
        }
      }
    }, [_vm._v("\n                " + _vm._s(key) + " (" + _vm._s(count) + ")\n              ")])
  }), 0), _vm._v(" "), (_vm.selectedPriority) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "tbl-flat"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Bag Seal Number")]), _vm._v(" "), _c('th', [_vm._v("Status / Action")])])]), _vm._v(" "), _c('tbody', [(_vm.bagList.unscanned.length === 0 && _vm.bagList.scanned.length === 0 && _vm.bagList.shortage.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bagList.unscanned), function(bag) {
    return _c('tr', {
      key: 'u' + bag
    }, [_c('td', [_vm._v(_vm._s(bag.masked))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-link text-danger",
      on: {
        "click": function($event) {
          return _vm.markShortage(bag.masked, bag.original)
        }
      }
    }, [_vm._v("Mark Shortage")])])])
  }), _vm._v(" "), _vm._l((_vm.bagList.scanned), function(bag) {
    return _c('tr', {
      key: 's' + bag,
      staticClass: "scanned-row"
    }, [_c('td', [_vm._v(_vm._s(bag))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-check text-success"
    })])])
  }), _vm._v(" "), _vm._l((_vm.bagList.shortage), function(bag) {
    return _c('tr', {
      key: 'sh' + bag
    }, [_c('td', [_vm._v(_vm._s(bag))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Shortage")])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [(!_vm.handoverStarted) ? _c('button', {
    staticClass: "common-success btn w-100",
    on: {
      "click": _vm.startHandover
    }
  }, [_vm._v("\n                Start Handover\n              ")]) : _c('button', {
    staticClass: "common-success btn w-100",
    attrs: {
      "disabled": !_vm.isAllBagsScanned()
    },
    on: {
      "click": _vm.approveHandover
    }
  }, [_vm._v("\n                Approve Handover\n              ")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "edit-bag-seal-modal",
      "size": "md",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": true,
      "no-close-on-esc": true,
      "no-enforce-focus": true,
      "body-class": "p-0"
    },
    on: {
      "hidden": _vm.onEditSealHidden
    },
    model: {
      value: (_vm.showEditSealModal),
      callback: function($$v) {
        _vm.showEditSealModal = $$v
      },
      expression: "showEditSealModal"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit Bag Seal")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeEditSealModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm edit-seal-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.editSealLoading
    },
    on: {
      "update:active": function($event) {
        _vm.editSealLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Old Bag Seal")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.editSealOldOriginal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("New Bag Seal "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editSealNew),
      expression: "editSealNew"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50|nxbPrefix'),
      expression: "'required|max:50|nxbPrefix'"
    }],
    staticClass: "form-control",
    class: {
      'border-danger': _vm.errors.has('editSeal.newBagSeal')
    },
    attrs: {
      "type": "text",
      "name": "newBagSeal",
      "data-vv-scope": "editSeal",
      "data-vv-as": "new bag seal",
      "placeholder": "Enter new bag seal number",
      "maxlength": "50",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.editSealNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editSealNew = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('editSeal.newBagSeal')),
      expression: "errors.has('editSeal.newBagSeal')"
    }],
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.errors.first('editSeal.newBagSeal')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Reason for Seal Change "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editSealReason),
      expression: "editSealReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'border-danger': _vm.errors.has('editSeal.reason')
    },
    attrs: {
      "name": "reason",
      "data-vv-scope": "editSeal",
      "data-vv-as": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editSealReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a reason")]), _vm._v(" "), _vm._l((_vm.editSealReasonOptions), function(opt) {
    return _c('option', {
      key: opt,
      domProps: {
        "value": opt
      }
    }, [_vm._v(_vm._s(opt))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('editSeal.reason')),
      expression: "errors.has('editSeal.reason')"
    }],
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.errors.first('editSeal.reason')))])]), _vm._v(" "), _c('div', {
    staticClass: "edit-seal-actions"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.editSealLoading
    },
    on: {
      "click": _vm.closeEditSealModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "common-success btn",
    attrs: {
      "type": "button",
      "disabled": _vm.editSealLoading
    },
    on: {
      "click": _vm.submitEditSeal
    }
  }, [_vm._v("Save")])])], 1)])])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-headerfrm"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor"
  }), _vm._v("\n          Bag Handover Requests\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Request Time | Date")]), _vm._v(" "), _c('th', [_vm._v("Total Bags")]), _vm._v(" "), _c('th', [_vm._v("Requested By")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('th', [_vm._v("Request ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22df5a69","hasScoped":true}!./src/views/components/FmBagHandover/FmBagHandover.html
// module id = 2050
// module chunks = 2